import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

/**
 * What screen the user is on, for tours that follow one page or one wizard step:
 * { pathname, agentStep, agentType, engStep, ctaStep, endScreenStep }. Read-only.
 */
export default function useTourContext() {
  const { pathname } = useLocation();
  const steps = useSelector(
    state => ({
      agentStep: state.agent?.etc?.agentStep,
      agentType: state.agent?.etc?.agentType,
      engStep: state.eng?.etc?.engStep,
      ctaStep: state.cta?.etc?.ctaStep,
      endScreenStep: state.endScreen?.etc?.endScreenStep,
    }),
    shallowEqual
  );
  return React.useMemo(() => ({ pathname, ...steps }), [pathname, steps]);
}
